import { render, staticRenderFns } from "./TableList.vue?vue&type=template&id=504c8617&"
import script from "./TableList.vue?vue&type=script&lang=js&"
export * from "./TableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('504c8617')) {
      api.createRecord('504c8617', component.options)
    } else {
      api.reload('504c8617', component.options)
    }
    module.hot.accept("./TableList.vue?vue&type=template&id=504c8617&", function () {
      api.rerender('504c8617', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examples/list/TableList.vue"
export default component.exports